import {
  FormatQuote as BlockquoteIcon,
  FormatListBulleted as BulletListIcon,
  DataObject as CodeBlockIcon,
  LooksOne as Heading1Icon,
  LooksTwo as Heading2Icon,
  Looks3 as Heading3Icon,
  FormatListNumbered as OrderedListIcon,
} from "@mui/icons-material";
import type { Editor } from "@tiptap/react";
import { FloatingMenu } from "@tiptap/react/menus";

import { Resources, useResource } from "Infrastructure/Translations/Resources";
import {
  MenuToolbar,
  ToolbarButton,
  ToolbarDivider,
} from "Shared/TextEditor/editorStyles";

interface EditorFloatingMenuProps {
  editor: Editor;
}

export const EditorFloatingMenu = ({
  editor,
}: EditorFloatingMenuProps): React.ReactNode => {
  const { t } = useResource();

  return (
    <FloatingMenu
      editor={editor}
      shouldShow={({ editor }) => {
        if (!editor.isActive("paragraph")) return false;
        const { $from } = editor.state.selection;
        return (
          $from.parent.isTextblock && $from.parent.textContent.length === 0
        );
      }}
    >
      <MenuToolbar>
        <ToolbarButton
          type="button"
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 1 }).run()
          }
          title={t(Resources.TextEditor.Heading1)}
        >
          <Heading1Icon />
        </ToolbarButton>
        <ToolbarButton
          type="button"
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 2 }).run()
          }
          title={t(Resources.TextEditor.Heading2)}
        >
          <Heading2Icon />
        </ToolbarButton>
        <ToolbarButton
          type="button"
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 3 }).run()
          }
          title={t(Resources.TextEditor.Heading3)}
        >
          <Heading3Icon />
        </ToolbarButton>
        <ToolbarDivider />
        <ToolbarButton
          type="button"
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          title={t(Resources.TextEditor.BulletList)}
        >
          <BulletListIcon />
        </ToolbarButton>
        <ToolbarButton
          type="button"
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          title={t(Resources.TextEditor.OrderedList)}
        >
          <OrderedListIcon />
        </ToolbarButton>
        <ToolbarButton
          type="button"
          onClick={() => editor.chain().focus().toggleBlockquote().run()}
          title={t(Resources.TextEditor.Blockquote)}
        >
          <BlockquoteIcon />
        </ToolbarButton>
        <ToolbarButton
          type="button"
          onClick={() => editor.chain().focus().toggleCodeBlock().run()}
          title={t(Resources.TextEditor.CodeBlock)}
        >
          <CodeBlockIcon />
        </ToolbarButton>
      </MenuToolbar>
    </FloatingMenu>
  );
};
